<template>
  <div>
    <div class="main-content">
      <div class="main-content-inner">
        <div class="breadcrumbs ace-save-state" id="breadcrumbs">
          <ul class="breadcrumb">
            <li>
              <i class="ace-icon fa fa-home home-icon"></i>
              <a href="#/">ダッシュボード</a>
            </li>
            <li class="active">鍵共有キー発行</li>
          </ul><!-- /.breadcrumb -->
        </div>
        <div class="page-header">
          <div class="checkbox">
            <h3>鍵共有キー発行</h3>
          </div>
        </div><!-- /.page-header -->
        <div class="page-content" style="padding-top: 100px;">
          <div id="loading" v-if="loading"><div class="loadingMsg"></div></div>
          <div class="alert alert-danger" id="error-alert">
            {{ message }}
          </div>
          <div class="alert alert-success" id="success-alert">
            {{ message }}
          </div>
          <div class="row">
            <div class="col-xs-12">
              <!-- PAGE CONTENT BEGINS -->
              <form class="form-horizontal" role="form">
              <div class="form-group">
                <label class="col-sm-2 no-padding-right">利用開始日時</label>
                <label class="no-padding-right float-left">いまから</label>
                <div class="col-sm-1">
                  <select class="form-control" v-model="passagesData.terms">
                    <option value="0">時間を選択</option>
                    <option v-for="item in listTimes" v-bind:value="item.value" v-bind:key="item.value">
                      {{item.text}}
                    </option>
                  </select>
                </div>
                <label class="no-padding-right float-left">後まで通門可能</label>
              </div>
              <div class="form-group">
                <label class="col-sm-2 no-padding-right">許可ゲート</label>
                <div class="col-sm-3">
                  <select class="form-control" data-placeholder="ゲート選択" id="gate" v-model="passagesData.gateId" :disabled="passagesData.terms === '0'">
                    <option value="0">ゲートを選択</option>
                    <option v-for="item in listGatePassages" v-bind:value="item.gateId.gateId" :key="item.gateId.gateId" v-if="item.gateId.gateId !== 'nodata'">
                      {{item.gateId.gateName}}
                    </option>
                    <option v-for="item in listGroupPassages" v-bind:value="item.gateId.gateId" :key="item.gateId.gateId" v-if="item.gateId.gateId !== 'nodata'">
                      {{item.gateId.gateName}}
                    </option>
                  </select>
                </div>
              </div>
              <div class="form-group">
                <div class="col-md-offset-2 col-sm-4">
                  <div class="checkbox">
                    <label>
                      <input name="form-field-checkbox" type="checkbox" class="ace" v-model="passagesData.isOnce">
                      <span class="lbl">1回限り有効</span>
                    </label>
                  </div>
                </div>
              </div>
              </form>
              <!-- PAGE CONTENT ENDS -->
            </div><!-- /.col -->
          </div><!-- /.row -->
          <div class="row">
            <div class="col-md-offset-2 col-sm-4">
              <button class="btn btn-info" type="button" @click="geneKey()" :disabled="passagesData.gateId === '0' || passagesData.terms === '0'">
                鍵共有キー発行
              </button>
            </div>
          </div>
          <div class="row">
            <div class="col-md-offset-2 col-sm-8">
              <div style="padding:10px 0px">下記の発行されたURLをコピーして利用者に共有してください。</div>
              <textarea id="geneLink" class="form-control" v-model="passagesData.result" rows="5" readonly></textarea>
            </div>
          </div>
          <div class="row">
            <div class="col-md-offset-2 col-sm-4">
              <button class="btn btn-info" type="button" @click="coppyClipboard()" style="margin-top:15px">
                クリップボードへコピー
              </button>
            </div>
          </div>
        </div><!-- /.page-content -->
      </div>
    </div><!-- /.main-content -->
  </div>
</template>

<script>
import * as Config from '../../config'
import moment from 'moment'

export default {
  data () {
    return {
      passagesData: {
        gateId: '0',
        terms: '0',
        isOnce: false,
        result: ''
      },
      listTimes: [
        { text: '1時間', value: 1 },
        { text: '2時間', value: 2 },
        { text: '3時間', value: 3 },
        { text: '4時間', value: 4 },
        { text: '5時間', value: 5 },
        { text: '6時間', value: 6 },
        { text: '7時間', value: 7 },
        { text: '8時間', value: 8 },
        { text: '9時間', value: 9 },
        { text: '10時間', value: 10 },
        { text: '11時間', value: 11 },
        { text: '12時間', value: 12 },
        { text: '13時間', value: 13 },
        { text: '14時間', value: 14 },
        { text: '15時間', value: 15 },
        { text: '16時間', value: 16 },
        { text: '17時間', value: 17 },
        { text: '18時間', value: 18 },
        { text: '19時間', value: 19 },
        { text: '20時間', value: 20 },
        { text: '21時間', value: 21 },
        { text: '22時間', value: 22 },
        { text: '23時間', value: 23 },
        { text: '24時間', value: 24 }
      ],
      existGateId: [],
      listGates: null,
      listGatePassages: null,
      listGroupPassages: [],
      listrelationsGateGroup: null,
      tempGroupPassages: null,
      loading: false,
      currentTime: '',
      message: ''
    }
  },
  created () {
    var vm = this
    vm.currentTime = vm.converTimestamp(Date())
    this.getInforGatePassage(localStorage.userProfileId)
    this.getInforGroupPassage(localStorage.userProfileId)
  },
  methods: {
    coppyClipboard () {
      var copyText = document.getElementById('geneLink')
      copyText.select()
      document.execCommand('copy')
    },
    // ゲート取得
    getInforGate (arrayDataName, userId, gateId, i) {
      if (jQuery.inArray(gateId, this.existGateId) !== -1) {
        arrayDataName[i].gateId = {gateId: 'nodata'}
      } else {
        this.existGateId.push(gateId)
        this.$http.get(Config.GATES_LIST_API + '?gateId=' + encodeURIComponent(gateId))
          .then(response => {
            if (response.body.gates[0].isValid && !response.body.gates[0].isVisitor) {
              arrayDataName[i].gateId = response.body.gates[0]
            } else {
              arrayDataName[i].gateId = {gateId: 'nodata'}
            }
          })
      }
    },
    // 期限付きゲート
    getInforGatePassage (userId) {
      var vm = this
      this.$http.get(Config.GATES_PASSAGE_API + '?userId=' + encodeURIComponent(userId) + '&notBefore=' + vm.currentTime + '&notAfter=' + vm.currentTime)
        .then(response => {
          if (response.body.maxRecords > 0) {
            vm.listGatePassages = response.body.passages
            for (var i = 0; i < vm.listGatePassages.length; i++) {
              vm.getInforGate(vm.listGatePassages, vm.listGatePassages[i].userId, vm.listGatePassages[i].gateId, i)
            }
            var tempData = []
            var tempResult = []
            for (var j = 0; j < vm.listGatePassages.length; j++) {
              if (tempData.indexOf(vm.listGatePassages[j].gateId) === -1) {
                tempData.push(vm.listGatePassages[j].gateId)
                tempResult.push(vm.listGatePassages[j])
              }
            }
            this.listGatePassages = tempResult
            console.log(this.listGatePassages)
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    // ゲート&グループ連関取得
    getGateGroup (userId, groupId, i) {
      var vm = this
      this.$http.get(Config.RELATION_GATE_GROUP_API + '?groupId=' + encodeURIComponent(groupId))
        .then(response => {
          vm.listrelationsGateGroup = response.body.relationsGateGroup
          for (var i = 0; i < vm.listrelationsGateGroup.length; i++) {
            vm.listGroupPassages.push(vm.listrelationsGateGroup[i])
          }
          for (var j = 0; j < vm.listGroupPassages.length; j++) {
            vm.getInforGate(vm.listGroupPassages, userId, vm.listGroupPassages[j].gateId, j)
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    // ゲートグループ通行権限取得
    getInforGroupPassage (userId) {
      var vm = this
      this.$http.get(Config.GROUPS_PASSAGE_API + '?userId=' + encodeURIComponent(userId))
        .then(response => {
          if (response.body.maxRecords > 0) {
            vm.tempGroupPassages = response.body.groupPassages
            for (var i = 0; i < vm.tempGroupPassages.length; i++) {
              vm.getGateGroup(vm.tempGroupPassages[i].userId, vm.tempGroupPassages[i].groupId, i)
            }
          } else {
            vm.listGroupPassages = null
          }
        })
        .catch((error) => {
          console.log(error)
          vm.listGroupPassages = null
        })
    },
    converTimestamp (t) {
      return parseInt(new Date(t) / 1000)
    },
    converDate (t) {
      return moment(new Date(t * 1000)).format('YYYY/MM/DD HH:mm')
    },
    geneKey () {
      var vm = this
      vm.loading = true
      const params = {
        'gateId': this.passagesData.gateId,
        'terms': this.passagesData.terms,
        'isOnce': this.passagesData.isOnce
      }
      console.log(params)
      this.$http.post(Config.KEY_SHARE_API, JSON.stringify(params))
        .then(response => {
          console.log(response)
          vm.loading = false
          this.passagesData.result = response.body.url
          this.message = '一時キー発行されました。'
          $('#success-alert').fadeTo(2000, 500).slideUp(500, function () {
            $('#success-alert').slideUp(500)
          })
        })
        .catch((error) => {
          vm.loading = false
          if (error.body) {
            this.message = Config.SERVER_CONNECT_ERROR
            $('#error-alert').fadeTo(2000, 500).slideUp(500, function () {
              $('#error-alert').slideUp(500)
            })
          } else {
            this.message = Config.SERVER_CONNECT_ERROR
            $('#error-alert').fadeTo(2000, 500).slideUp(500, function () {
              $('#error-alert').slideUp(500)
            })
          }
        })
    }
  }
}
</script>
<style>
 .checkbox{
  padding-top: 0px
 }
  .action{
    text-align: right;
  }
  .float-left{
    float: left;
    padding-left: 12px
  }
</style>



// WEBPACK FOOTER //
// src/views/key/KeyAdd.vue